import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TipoPortal } from '../../services/authService/auth.service';

type CardItem = {
  icon: string;
  label: string;
  file?: string;
  files?: { ano: string; file: string }[];
};

@Component({
  selector: 'app-portal-cards',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatIconModule, FlexLayoutModule],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  portal!: TipoPortal;
  cards: CardItem[] = [];
  expandedCardIndex: number | null = null;
  subcards: { ano: string, file: string }[] = [];
  tituloSubcard: string | null = null;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.portal = this.route.snapshot.data['portal'];
    const usuarioRaw = localStorage.getItem('usuarioLogado');
    const usuario = usuarioRaw ? JSON.parse(usuarioRaw) : null;
  
    console.log('Portal:', this.portal);
    console.log('Usuário logado:', usuario);
  
    this.cards = usuario ? this.getCardsPorUsuario(usuario) : [];
  }

  toggleExpand(index: number): void {
    this.expandedCardIndex = this.expandedCardIndex === index ? null : index;
  }

  abrirPDF(filePath: string): void {
    const fullPath = `assets/${encodeURIComponent(filePath)}`;
    window.open(fullPath, '_blank');
  }

  abrirSubcards(card: CardItem): void {
    if (card.files) {
      this.subcards = card.files;
      this.tituloSubcard = card.label;
    } else if (card.file) {
      this.abrirPDF(card.file);
    }
  }

  getCardsPorUsuario(usuario: string): CardItem[] {
    if (this.portal === 'aluno') {
      const map: Record<string, CardItem[]> = {
        '4262712': [ // BRYAN
          { icon: 'event', label: 'Calendário', file: 'docs/alunos/VOLPI_CALENDARIO_FUND.pdf' },
          { icon: 'grading', label: 'Boletim Escolar', file: 'docs/alunos/VOLPI_1A_BRYAN NIDIALCOV ALVES DA SILVA.pdf' },
          { icon: 'schedule', label: 'Quadro de Horários', file: 'docs/alunos/VOLPI_1A_GRADE.pdf' },
          { icon: 'assignment', label: 'Observações de Atividades', file: 'docs/alunos/VOLPI_1A_OBS_BRYAN NIDIALCOV ALVES DA SILVA.pdf' },
        ],
        '4272171': [ // KEROLLYN
          { icon: 'event', label: 'Calendário', file: 'docs/alunos/VOLPI_CALENDARIO_FUND.pdf' },
          { icon: 'grading', label: 'Boletim Escolar', file: 'docs/alunos/VOLPI_1A_KEROLLYN DA SILVA BORGES.pdf' },
          { icon: 'schedule', label: 'Quadro de Horários', file: 'docs/alunos/VOLPI_1A_GRADE.pdf' },
          { icon: 'assignment', label: 'Observações de Atividades', file: 'docs/alunos/VOLPI_1A_OBS_KEROLLYN DA SILVA BORGES.pdf' },
        ],
        '554077': [ // EMILLY
          {
            icon: 'event',
            label: 'Calendário',
            files: [
              { ano: '2024', file: 'docs/alunos/VOLPI_CALENDARIO_2024.pdf' },
              { ano: '2025', file: 'docs/alunos/VOLPI_CALENDARIO_FUND.pdf' },
            ]
          },
          { icon: 'grading', label: 'Boletim Escolar', file: 'docs/alunos/2025_VOLPI_5A_EMILLY VYTORIA CARVALHO TENORIO.pdf' },
          { icon: 'schedule', label: 'Quadro de Horários', file: 'docs/alunos/VOLPI_5A_GRADE.pdf' },
          { icon: 'assignment', label: 'Observações de Atividades', file: 'docs/alunos/2025_VOLPI_5A_OBS_EMILLY VYTORIA CARVALHO TENORIO.pdf' },
        ],
        '516693': [ // ALYCE
          { icon: 'event', label: 'Calendário', file: 'docs/alunos/VOLPI_CALENDARIO_FUND.pdf' },
          { icon: 'grading', label: 'Boletim Escolar', file: 'docs/alunos/VOLPI_5A_ALYCE ISABELLY MARTINS SENA.pdf' },
          { icon: 'schedule', label: 'Quadro de Horários', file: 'docs/alunos/VOLPI_5A_GRADE.pdf' },
          { icon: 'assignment', label: 'Observações de Atividades', file: 'docs/alunos/VOLPI_5A_OBS_ALYCE ISABELLY MARTINS SENA.pdf' },
        ],
      };
      return map[usuario] || [];
    }

    if (this.portal === 'professor') {
      const map: Record<string, CardItem[]> = {
        '27704303864': [ // REGIANE
          {
            icon: 'event',
            label: 'Calendário',
            file: 'docs/alunos/VOLPI_CALENDARIO_FUND.pdf',
          },
          {
            icon: 'calendar_month',
            label: 'Quadro de Horários',
            file: 'docs/alunos/VOLPI_1A_GRADE.pdf',
          },
        ],
        '25169677804': [ // ABIQUELA
          {
            icon: 'event',
            label: 'Calendário',
            file: 'docs/alunos/VOLPI_CALENDARIO_FUND.pdf',
          },
          {
            icon: 'calendar_month',
            label: 'Quadro de Horários',
            file: 'docs/alunos/VOLPI_1A_GRADE.pdf',
          },
        ],
        '62173328093': [ // PROFESSOR DEMONSTRAÇÃO
          {
            icon: 'event',
            label: 'Calendário',
            file: 'docs/alunos/BRAGUINHA_CALENDARIO_INF.pdf',
          },
          {
            icon: 'calendar_month',
            label: 'Quadro de Horários',
            file: 'docs/alunos/BRAGUINHA_EIIA_GRADE.pdf',
          },
        ],
      };
    
      return map[usuario] || [];
    }    

    if (this.portal === 'familia') {
      const map: Record<string, CardItem[]> = {
        '37340631836': [ // PAMELA
          {
            icon: 'event',
            label: 'Calendário',
            files: [
              { ano: '2024', file: 'docs/alunos/VOLPI_CALENDARIO_2024.pdf' },
              { ano: '2025', file: 'docs/alunos/VOLPI_CALENDARIO_FUND.pdf' },
            ]
          },
          { icon: 'grading', label: 'Boletim Escolar', file: 'docs/alunos/2025_VOLPI_5A_EMILLY VYTORIA CARVALHO TENORIO.pdf' },
          { icon: 'schedule', label: 'Quadro de Horários', file: 'docs/alunos/VOLPI_5A_GRADE.pdf' },
          { icon: 'assignment', label: 'Observações de Atividades', file: 'docs/alunos/2025_VOLPI_5A_OBS_EMILLY VYTORIA CARVALHO TENORIO.pdf' },
        ],
        '28688323852': [ // ROSIRES
          { icon: 'event', label: 'Calendário', file: 'docs/alunos/VOLPI_CALENDARIO_FUND.pdf' },
          { icon: 'grading', label: 'Boletim Escolar', file: 'docs/alunos/VOLPI_1A_EMILLY DA SILVA XAVIER.pdf' },
          { icon: 'schedule', label: 'Quadro de Horários', file: 'docs/alunos/VOLPI_1A_GRADE.pdf' },
          { icon: 'assignment', label: 'Observações de Atividades', file: 'docs/alunos/VOLPI_1A_OBS_EMILLY DA SILVA XAVIER.pdf' },
        ],
        '90778382010': [ // avó
          { icon: 'event', label: 'Calendário', file: 'docs/alunos/VOLPI_CALENDARIO_FUND.pdf' },
          { icon: 'grading', label: 'Boletim Escolar', file: 'docs/alunos/VOLPI_1A_BRYAN NIDIALCOV ALVES DA SILVA.pdf' },
          { icon: 'schedule', label: 'Quadro de Horários', file: 'docs/alunos/VOLPI_1A_GRADE.pdf' },
          { icon: 'assignment', label: 'Observações de Atividades', file: 'docs/alunos/VOLPI_1A_OBS_BRYAN NIDIALCOV ALVES DA SILVA.pdf' },
        ],
      };
      return map[usuario] || [];
    }

    return [];
  }

  getPortalTitle(): string {
    const titles: Record<TipoPortal, string> = {
      aluno: 'Portal do Aluno',
      professor: 'Portal dos Educadores',
      familia: 'Portal da Família/Responsáveis',
    };
    return titles[this.portal];
  }

  getTitleClass(): string {
    const classes: Record<TipoPortal, string> = {
      aluno: 'yellow',
      professor: 'red',
      familia: 'blue',
    };
    return classes[this.portal];
  }
}
